module.exports = __webpack_public_path__ + "img/最近.be838644.png";